import { IxCheckbox } from './IxCheckbox.js';

customElements.define('ix-checkbox', IxCheckbox);
